import './style/main.css'
import './style/necro.css'
import Application from './javascript/Application.js'

window.application = new Application({
    $canvas: document.querySelector('.js-canvas'),
    useComposer: true
})

window.advanceMilestone = () =>
{
    const state = window.application.world?.state
    return state ? state.advanceMilestone() : 'Game is still loading. Try again shortly.'
}

window.completeWave = () =>
{
    const state = window.application.world?.state
    return state ? state.completeWaveForDebug() : 'Game is still loading. Try again shortly.'
}
